import pluralize from "pluralize";
import { ETHNIC_GROUP_CATEGORY_MODEL } from "@/models/ethnic-group-category-model";

export const ETHNIC_GROUP_MODEL = "ethnic-group";

const ethnicGroupModel = {
  name: "",
  category: {
    jsonApi: "hasOne",
    type: pluralize(ETHNIC_GROUP_CATEGORY_MODEL)
  }
};

export default ethnicGroupModel;
